<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();

// State
const page = ref(1)
const perPage = ref(10)

// Computed
const userId = computed(() => proxy.$store.state.user.id)
const list = computed(() => proxy.$store.state.notices)
const totalCount = computed(() => proxy.$store.state.noticesTotal)

const getList = async () => {
  await proxy.$store.dispatch('fetchNotices', {
    page: page.value,
    perPage: perPage.value,
  })
}

const handlePageChange = (newPage) => {
  page.value = newPage
  getList()
}

const handleView = async (id) => {
  try {
    const notice = list.value.find(item => item.id === id)
    if (notice) {
      // TODO: 읽음 처리
      // notice.read = userId.value.toString()
    }
    
    const contentElement = event.target
      .closest('.title-notify')
      .parentElement
      .querySelector('.notice_content')
    contentElement.style.display = 'block'
    document.body.style.overflow = 'hidden'
  } catch (error) {
    console.error('Failed to update notice view:', error)
  }
}

const handleClose = (event) => {
  const contentElement = event.target.closest('.notice_content')
  contentElement.style.display = 'none'
  document.body.style.overflow = 'initial'
}

const isUnread = (userView, currentUserId) => {
  if (!userView || !currentUserId) return true
  return !userView.split(',').map(Number).includes(currentUserId)
}

onMounted(() => {
  getList()
})
</script>

<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">{{ t('common.number') }}</th>
        <th scope="col">{{ t('common.title') }}</th>
        <th scope="col">{{ t('common.date') }}</th>
        <th scope="col" class="hidden">{{ t('common.status') }}</th>
      </tr>
    </thead>
    <tbody v-if="list.length > 0">
      <tr v-for="(item, index) in list" :key="index">
        <td>{{ index + 1 }}</td>
        <td>
          <div class="title-notify" @click="handleView(item.id)">
            <p>{{ item.title }}</p>
          </div>
          <div class="notice_content hidepp">
            <div class="flex_popup">
              <div class="showtb overflow-visible">
                <div class="whitespace-pre-wrap">
                  <p class="titlenoti">{{ item.title }}</p>
                  <div v-html="item.content.replace('\\n', '<br />')"></div>
                </div>
                <button class="close-subpage !w-10 !h-10 top-[-13px] right-[-13px]" @click="handleClose">
                  x
                </button>
              </div>
            </div>
          </div>
        </td>
        <td>{{ new Date(item.created_at).toLocaleString() }}</td>
        <td class="hidden">
          {{ isUnread(item.read, userId) ? t('notice.unread') : t('notice.read') }}
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="100" class="text-center">{{ t('common.noData') }}</td>
      </tr>
    </tbody>
  </table>
  <nav class="custom-pagination">
    <paginate
      @update:modelValue="handlePageChange"
      :total-count="totalCount"
      :limit="perPage"
      v-model="page"
    ></paginate>
  </nav>
</template>

<style scoped>
.title-notify {
  cursor: pointer;
}

.notice_content {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.flex_popup {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.showtb {
  background: white;
  padding: 2rem;
  border-radius: 0.5rem;
  position: relative;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.close_noti {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
